var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import RightChevron from "react-icons/lib/fa/chevron-right";
import styled from "styled-components";
export default styled(RightChevron)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  transform: rotate(0deg);\n"], ["\n  transform: rotate(0deg);\n"])));
var templateObject_1;
